import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import defaultLayout from '@/layout/default';
import LoginPage from '@/views/LoginPage';
import authLayout from '@/layout/auth';
import vuetify, { defaults } from '@/plugins/vuetify';
import { supplierType, productMedicalType, clinicMembership, RESTFUL } from '@/data/constants';
import { roles } from '@/data/constants';
import api from '@/api';
import { crudRead } from '@/api/crud';
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: defaultLayout,
    redirect: { name: 'timetables' },
    children: [
      // {
      //   path: '/dashboard',
      //   name: 'Dashboard',
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/Dashboard'),
      //   meta: {
      //     auth: ['admin'],
      //   },
      //   // props: r => ({ selectedRole: r.query.role }),
      // },
      // {
      //   path: '/profiles',
      //   name: 'Profiles',
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/Identities'),
      //   meta: {
      //     auth: [roles.admin],
      //   },
      //   props: r => ({ selectedRole: r.query.role }),
      // },
      {
        path: '/members',
        name: 'Members',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Identities'),
        meta: {
          auth: [roles.admin],
          uniqueComponent: true,
        },
        props: r => ({ selectedRole: roles.member }),
      },
      {
        path: '/members/:id([0-9a-zA-Z]{24})',
        name: 'Member',
        component: () =>
          import(/* webpackChunkName: "admin" */ '../views/Identities/memberProfileDetails.vue'),
        meta: {
          auth: [roles.admin, roles.clinicStaff],
        },
        props: r => ({ id: r.params.id, editMode: !!r.query.edit }),
      },
      // {
      //   path: '/doctors',
      //   name: 'Doctors',
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/Identities'),
      //   meta: {
      //     auth: ['admin', 'bn.cashier'],
      //     uniqueComponent: true,
      //   },
      //   props: r => ({ selectedRole: 'bn.master' }),
      // },
      // {
      //   path: '/dispensers',
      //   name: 'Dispensers',
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/Identities'),
      //   meta: {
      //     auth: ['admin', 'bn.cashier'],
      //     uniqueComponent: true,
      //   },
      //   props: r => ({ selectedRole: 'bn.dispenser' }),
      // },
      // {
      //   path: '/nurses',
      //   name: 'Nurses',
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/Identities'),
      //   meta: {
      //     auth: ['admin', 'bn.cashier'],
      //     uniqueComponent: true,
      //   },
      //   props: r => ({ selectedRole: 'bn.cashier' }),
      // },
      // {
      //   path: '/accountants',
      //   name: 'Accountants',
      //   //component: () => import(/* webpackChunkName: "admin" */ '../views/Identities'),
      //   meta: {
      //     auth: ['admin'],
      //     uniqueComponent: true,
      //   },
      //   props: r => ({ selectedRole: 'rml.accountant' }),
      // },
      {
        path: '/admins',
        name: 'Admins',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Identities'),
        meta: {
          auth: [roles.admin],
        },
        props: r => ({ selectedRole: roles.admin }),
      },
      {
        path: '/profiles/:id([0-9a-zA-Z]{24})',
        alias: ['/admins/:id([0-9a-zA-Z]{24})'],
        name: 'Profile',
        component: () =>
          import(/* webpackChunkName: "admin" */ '../views/Identities/identityDetails'),
        meta: {
          auth: [roles.admin, roles.clinicStaff],
          uniqueComponent: true,
        },
        props: r => ({ id: r.params.id, editMode: !!r.query.edit }),
      },
      {
        path: '/myProfile',
        name: 'myProfile',
        component: () => import(/* webpackChunkName: "master" */ '../views/MyProfile.vue'),
        meta: {
          auth: [roles.admin, roles.clinicStaff],
        },
      },
      // {
      //   path: '/serviceProducts',
      //   name: 'serviceProducts',
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/ServiceProduct'),
      //   meta: {
      //     auth: ['admin', 'bn.master', 'bn.cashier'],
      //   },
      // },
      // {
      //   path: '/serviceProducts/:id([0-9a-zA-Z]{24})',
      //   name: 'serviceProduct',
      //   component: () =>
      //     import(/* webpackChunkName: "admin" */ '../views/ServiceProduct/serviceProductDetails'),
      //   props: r => ({ id: r.params.id, editMode: !!r.query.edit }),
      //   meta: {
      //     auth: ['admin', 'bn.master', 'bn.cashier'],
      //   },
      // },
      {
        path: '/booking',
        name: 'bookings',
        component: () => import(/* webpackChunkName: "master" */ '../views/Booking'),
        meta: {
          auth: [roles.admin, roles.clinicStaff],
        },
      },
      // {
      //   path: '/transactions',
      //   name: 'transactions',
      //   component: () => import(/* webpackChunkName: "master" */ '../views/Transaction'),
      //   meta: {
      //     auth: ['admin', 'bn.cashier'],
      //   },
      // },
      // {
      //   path: '/billing',
      //   name: 'billings',
      //   component: () => import(/* webpackChunkName: "master" */ '../views/Billing'),
      //   meta: {
      //     auth: ['admin', 'bn.cashier', 'bn.dispenser'],
      //   },
      // },
      // {
      //   path: '/billing/:id([0-9a-zA-Z]{24})',
      //   name: 'billing',
      //   component: () =>
      //     import(/* webpackChunkName: "master" */ '../views/Billing/billingDetails.vue'),
      //   props: r => ({ id: r.params.id }),
      //   meta: {
      //     auth: ['admin', 'bn.cashier', 'bn.dispenser'],
      //   },
      // },
      // {
      //   path: '/billing/new',
      //   name: 'billingNew',
      //   component: () =>
      //     import(/* webpackChunkName: "master" */ '../views/Billing/billingDetails.vue'),
      //   props: r => ({ id: 'new', copyFrom: r.query.copyFrom, booking: r.query.booking }),
      //   meta: {
      //     auth: ['admin', 'bn.master', 'bn.cashier'],
      //   },
      // },
      // {
      //   path: '/billingItem',
      //   name: 'billingItems',
      //   component: () =>
      //     import(/* webpackChunkName: "master" */ '../views/Billing/billingItems.vue'),
      //   meta: {
      //     auth: ['admin', 'bn.cashier'],
      //   },
      // },
      // {
      //   path: '/clockInRecords',
      //   name: 'clockInRecords',
      //   component: () => import(/* webpackChunkName: "master" */ '../views/ClockInRecord'),
      //   meta: {
      //     auth: ['admin', 'bn.cashier'],
      //   },
      // },
      // {
      //   path: '/booking/:id([0-9a-zA-Z]{24})',
      //   name: 'booking',
      //   component: () => import(/* webpackChunkName: "master" */ '../views/Booking/bookingDetails'),
      //   props: r => ({ id: r.params.id, editMode: !!r.query.edit }),
      //   meta: {
      //     auth: [roles.admin, roles.clinicStaff],
      //   },
      // },
      {
        path: '/timetable',
        name: 'timetables',
        component: () => import(/* webpackChunkName: "master" */ '../views/Timetable'),
        meta: {
          fullscreen: true,
          auth: [roles.admin, roles.clinicStaff],
        },
      },
      // {
      //   path: '/appointment',
      //   name: 'appointments',
      //   component: () => import(/* webpackChunkName: "master" */ '../views/Appointment'),
      //   meta: {
      //     auth: ['admin', 'bn.master', 'bn.cashier', 'bn.dispenser'],
      //   },
      // },
      // {
      //   path: '/productCategory',
      //   name: 'productCategories',
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/ProductCategory'),
      //   meta: {
      //     auth: ['admin', 'bn.master', 'bn.cashier'],
      //   },
      // },
      // {
      //   path: '/productCategory/:id([0-9a-zA-Z]{24})',
      //   name: 'productCategory',
      //   component: () =>
      //     import(/* webpackChunkName: "admin" */ '../views/ProductCategory/ProductCategoryDetails'),
      //   props: r => ({ id: r.params.id, editMode: !!r.query.edit }),
      //   meta: {
      //     auth: ['admin', 'bn.cashier', 'bn.master'],
      //   },
      // },
      {
        path: '/Notification',
        name: 'Notification',
        component: () => import(/* webpackChunkName: "master" */ '../views/Notification/index'),
        meta: {
          auth: [roles.admin, roles.clinicStaff],
        },
      },
      // {
      //   path: '/CustomSetting',
      //   name: 'CustomSetting',
      //   component: () => import(/* webpackChunkName: "master" */ '../views/CustomSetting/index'),
      //   meta: {
      //     auth: ['admin', 'bn.cashier'],
      //   },
      // },
      {
        path: '/clinicProfiles',
        name: 'clinicProfiles',
        component: () => import(/* webpackChunkName: "admin" */ '../views/ClinicProfile'),
        meta: {
          auth: [roles.admin],
        },
      },
      {
        path: '/clinicProfiles/:id([0-9a-zA-Z]{24})',
        name: 'clinicProfile',
        component: () =>
          import(/* webpackChunkName: "admin" */ '../views/ClinicProfile/ClinicProfileDetails'),
        props: r => ({ id: r.params.id, editMode: !!r.query.edit }),
        meta: {
          auth: [roles.admin],
        },
      },
      {
        path: '/clinicProfiles/new',
        name: 'clinicProfileNew',
        component: () =>
          import(/* webpackChunkName: "admin" */ '../views/ClinicProfile/ClinicProfileDetails'),
        props: r => ({ id: 'new' }),
        meta: {
          auth: [roles.admin],
        },
      },
      {
        path: '/myClinic',
        name: 'myClinic',
        component: () => import(/* webpackChunkName: "admin" */ '../views/MyClinic'),
        meta: {
          auth: [roles.clinicStaff],
        },
      },
      {
        path: '/doctors',
        name: 'doctors',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Doctors'),
        meta: {
          auth: [roles.clinicStaff],
        },
      },
      {
        path: '/staff',
        name: 'staff',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Staff'),
        meta: {
          auth: [roles.clinicStaff],
        },
      },
      // {
      //   path: '/leaveApplication',
      //   name: 'leaveApplications',
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/LeaveApplication'),
      //   meta: {
      //     auth: ['admin', 'bn.master'],
      //   },
      // },
      // {
      //   path: '/leaveApplication/:id([0-9a-zA-Z]{24})',
      //   name: 'leaveApplication',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "admin" */ '../views/LeaveApplication/LeaveApplicationDetails'
      //     ),
      //   props: r => ({ id: r.params.id, editMode: !!r.query.edit }),
      //   meta: {
      //     auth: ['admin', 'bn.master'],
      //   },
      // },
      // {
      //   path: '/TeachingTask',
      //   name: 'TeachingTasks',
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/TeachingTask'),
      //   meta: {
      //     auth: ['admin'],
      //     isDevOnly: true,
      //   },
      // },
      // {
      //   path: '/TeachingTask/:id([0-9a-zA-Z]{24})',
      //   name: 'TeachingTask',
      //   component: () =>
      //     import(/* webpackChunkName: "admin" */ '../views/TeachingTask/TeachingTaskDetails'),
      //   props: r => ({ id: r.params.id, editMode: !!r.query.edit, selectedTab: r.query.tab }),
      //   meta: {
      //     auth: ['admin'],
      //     isDevOnly: true,
      //   },
      // },
      // {
      //   path: '/EmployeeContract',
      //   name: 'EmployeeContracts',
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/EmployeeContract'),
      //   meta: {
      //     auth: ['admin', 'bn.master'],
      //     isDevOnly: true,
      //   },
      // },
      // {
      //   path: '/EmployeeContract/:id([0-9a-zA-Z]{24})',
      //   name: 'EmployeeContract',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "admin" */ '../views/EmployeeContract/EmployeeContractDetails'
      //     ),
      //   props: r => ({ id: r.params.id, editMode: !!r.query.edit, selectedTab: r.query.tab }),
      //   meta: {
      //     auth: ['admin', 'bn.master'],
      //     isDevOnly: true,
      //   },
      // },
      // {
      //   path: '/EmployeeContract/new',
      //   name: 'EmployeeContractNew',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "admin" */ '../views/EmployeeContract/EmployeeContractDetails'
      //     ),
      //   props: r => ({ id: 'new', editMode: !!r.query.edit, selectedTab: r.query.tab }),
      //   meta: {
      //     auth: ['admin', 'bn.master'],
      //     isDevOnly: true,
      //   },
      // },

      // {
      //   path: '/payroll',
      //   name: 'payrolls',
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/Payroll/index'),
      //   meta: {
      //     auth: ['admin', 'bn.master'],
      //     isDevOnly: true,
      //   },
      // },
      // {
      //   path: '/payroll/:id([0-9a-zA-Z]{24})',
      //   name: 'payroll',
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/Payroll/PayrollDetails'),
      //   props: r => ({ id: r.params.id, editMode: !!r.query.edit }),
      //   meta: {
      //     auth: ['admin', 'bn.master'],
      //     isDevOnly: true,
      //   },
      // },
      // {
      //   path: '/payroll/new',
      //   name: 'payrollStep',
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/Payroll/new'),
      //   props: r => ({
      //     selectedStep: r.query.step,
      //     selectedDate: r.query.date,
      //     selectedMid: r.query.mid,
      //   }),
      //   meta: {
      //     auth: ['admin', 'bn.master'],
      //     isDevOnly: true,
      //   },
      // },

      {
        path: '/changeMasterPassword/:id([0-9a-zA-Z]{24})',
        name: 'changeMasterPassword',
        component: () =>
          import(
            /* webpackChunkName: "changePassword" */ '../views/Identities/changeMasterPassword'
          ),
        props: r => ({ id: r.params.id }),
      },
      {
        path: '/changeMasterUserName/:id([0-9a-zA-Z]{24})',
        name: 'changeMasterUserName',
        component: () =>
          import(
            /* webpackChunkName: "changePassword" */ '../views/Identities/changeMasterUserName'
          ),
        props: r => ({ id: r.params.id }),
      },
      // {
      //   path: '/physicalProducts',
      //   name: 'physicalProducts',
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/PhysicalProduct/index'),
      //   meta: {
      //     auth: ['admin', 'bn.master'],
      //   },
      // },
      // {
      //   path: '/physicalProducts/:id([0-9a-zA-Z]{24})',
      //   name: 'physicalProduct',
      //   component: () =>
      //     import(/* webpackChunkName: "admin" */ '../views/PhysicalProduct/PhysicalProductDetails'),
      //   props: r => ({ id: r.params.id, editMode: !!r.query.edit }),
      //   meta: {
      //     auth: ['admin', 'bn.master'],
      //   },
      // },
      // {
      //   path: '/physicalProductOrders',
      //   name: 'physicalProductOrders',
      //   component: () =>
      //     import(/* webpackChunkName: "admin" */ '../views/PhysicalProductOrder/index'),
      //   meta: {
      //     auth: ['admin', 'bn.cashier'],
      //   },
      // },
      // {
      //   path: '/physicalProductOrders/:id([0-9a-zA-Z]{24})',
      //   name: 'physicalProductOrder',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "admin" */ '../views/PhysicalProductOrder/PhysicalProductOrderDetails'
      //     ),
      //   props: r => ({ id: r.params.id, editMode: !!r.query.edit }),
      //   meta: {
      //     auth: ['admin', 'bn.cashier'],
      //   },
      // },
      // {
      //   path: '/medicine/:id([0-9a-zA-Z]{24})',
      //   name: 'medicament',
      //   alias: '/sample/:id([0-9a-zA-Z]{24})',
      //   component: () =>
      //     import(/* webpackChunkName: "admin" */ '../views/Medicament/MedicamentDetails'),
      //   props: r => ({ id: r.params.id, editMode: !!r.query.edit }),
      //   meta: {
      //     auth: ['admin', 'bn.master', 'bn.cashier', 'bn.dispenser'],
      //   },
      // },
      // {
      //   path: '/medicine/new',
      //   name: 'medicamentNew',
      //   component: () =>
      //     import(/* webpackChunkName: "admin" */ '../views/Medicament/MedicamentDetails'),
      //   props: r => ({ id: 'new', defaultMedicalType: r.query.defaultMedicalType }),
      //   meta: {
      //     auth: ['admin', 'bn.master', 'bn.cashier', 'bn.dispenser'],
      //   },
      // },
      // {
      //   path: '/sample/new',
      //   name: 'sampleNew',
      //   component: () =>
      //     import(/* webpackChunkName: "admin" */ '../views/Medicament/MedicamentDetails'),
      //   props: r => ({ id: 'new', defaultMedicalType: productMedicalType.sample }),
      //   meta: {
      //     auth: ['admin', 'bn.master', 'bn.cashier'],
      //   },
      // },
      // {
      //   path: '/medicine',
      //   name: 'medicaments',
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/Medicament/index'),
      //   meta: {
      //     auth: ['admin', 'bn.master', 'bn.cashier', 'bn.dispenser'],
      //   },
      // },
      // {
      //   path: '/sample',
      //   name: 'samples',
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/Medicament/index'),
      //   meta: {
      //     auth: ['admin', 'bn.master', 'bn.cashier'],
      //     uniqueComponent: true,
      //   },
      //   props: r => ({ isSample: true }),
      // },
      // {
      //   path: '/consultation',
      //   name: 'Consultations',
      //   component: () => import(/* webpackChunkName: "consultation" */ '../views/Consultation'),
      //   props: r => ({ patient: r.query.patient }),
      //   meta: {
      //     auth: ['admin', 'bn.master', 'bn.cashier', 'bn.dispenser'],
      //   },
      // },
      // {
      //   path: '/consultation/:id([0-9a-zA-Z]{24})',
      //   name: 'Consultation',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "consultation" */ '../views/Consultation/ConsultationDetails.vue'
      //     ),
      //   props: r => ({ id: r.params.id }),
      //   meta: {
      //     auth: ['admin', 'bn.master', 'bn.cashier', 'bn.dispenser'],
      //   },
      // },
      // {
      //   path: '/consultation/new',
      //   name: 'ConsultationNew',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "consultation" */ '../views/Consultation/ConsultationDetails.vue'
      //     ),
      //   props: r => ({ id: '', booking: r.query.booking }),
      //   meta: {
      //     auth: ['admin', 'bn.master', 'bn.cashier'],
      //   },
      // },
      // {
      //   path: '/consultationOverview/:id([0-9a-zA-Z]{24})',
      //   name: 'ConsultationOverview',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "consultation" */ '../views/Consultation/ConsultationOverview.vue'
      //     ),
      //   props: r => ({ id: r.params.id, booking: r.query.booking }),
      //   meta: {
      //     auth: ['admin', 'bn.master', 'bn.cashier', 'bn.dispenser'],
      //   },
      // },
      // {
      //   path: '/patientConsultation/:id([0-9a-zA-Z]{24})/',
      //   name: 'PatientConsultation',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "patientConsultation" */ '../views/PatientConsultation/PatientConsultation.vue'
      //     ),
      //   props: r => ({ id: r.params.id }),
      //   meta: {
      //     auth: ['admin', 'bn.master', 'bn.cashier'],
      //   },
      //   children: [
      //     {
      //       path: 'medicalHistory',
      //       name: 'MedicalHistory',
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "medicalHistory" */ '../views/PatientConsultation/MedicalHistory.vue'
      //         ),
      //       props: r => ({ booking: r.query.booking }),
      //       meta: {
      //         auth: ['admin', 'bn.master', 'bn.cashier'],
      //       },
      //     },
      //   ],
      // },
      // {
      //   path: '/medication',
      //   name: 'Medication',
      //   component: () => import(/* webpackChunkName: "medication" */ '../views/Medication'),
      //   props: r => ({ patient: r.query.patient }),
      //   meta: {
      //     auth: ['admin', 'bn.cashier', 'bn.master', 'bn.dispenser'],
      //   },
      // },

      // {
      //   path: '/medication/purchase/:id([0-9a-zA-Z]{24})',
      //   name: 'purchaseMedication',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "medication" */ '../views/Consultation/ConsultationOverview.vue'
      //     ),
      //   props: r => ({
      //     id: r.params.id,
      //     purchaseSetting: { isPurchase: true, ...r.params.purchaseSetting },
      //   }),
      //   meta: {
      //     auth: ['admin', 'bn.master', 'bn.cashier', 'bn.dispenser'],
      //   },
      // },
      // {
      //   path: '/medication/purchase/:cid([0-9a-zA-Z]{24})/:bid([0-9a-zA-Z]{24})',
      //   name: 'viewMedication',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "medication" */ '../views/Consultation/ConsultationOverview.vue'
      //     ),
      //   props: r => ({
      //     id: r.params.cid, //client id
      //     purchaseSetting: { isPurchase: true, billing: r.params.bid },
      //   }),
      //   meta: {
      //     auth: ['admin', 'bn.cashier', 'bn.dispenser'],
      //   },
      // },
      // {
      //   path: '/post',
      //   name: 'posts',
      //   component: () => import(/* webpackChunkName: "post" */ '../views/Posts'),
      //   props: r => ({ patient: r.query.patient }),
      //   meta: {
      //     auth: ['admin'],
      //   },
      // },
      // {
      //   path: '/post/:id([0-9a-zA-Z]{24})',
      //   name: 'post',
      //   component: () => import(/* webpackChunkName: "post" */ '../views/Posts/PostDetails.vue'),
      //   props: r => ({ id: r.params.id }),
      //   meta: {
      //     auth: ['admin'],
      //   },
      // },
      // {
      //   path: '/post/new',
      //   name: 'postNew',
      //   component: () => import(/* webpackChunkName: "post" */ '../views/Posts/PostDetails.vue'),
      //   props: r => ({ id: 'new', booking: r.query.booking }),
      //   meta: {
      //     auth: ['admin'],
      //   },
      // },
      // {
      //   path: '/suppliers/laboratories',
      //   name: 'suppliersLaboratories',
      //   props: r => ({ selectedType: supplierType.laboratory }),
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/Suppliers/index.vue'),
      //   meta: {
      //     auth: ['admin', 'bn.cashier'],
      //     uniqueComponent: true,
      //   },
      // },
      // {
      //   path: '/suppliers/pharmas',
      //   name: 'suppliersPharmas',
      //   props: r => ({ selectedType: supplierType.pharma }),
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/Suppliers/index.vue'),
      //   meta: {
      //     auth: ['admin', 'bn.cashier'],
      //     uniqueComponent: true,
      //   },
      // },
      // {
      //   path: '/suppliers/couriers',
      //   name: 'suppliersCouriers',
      //   props: r => ({ selectedType: supplierType.courier }),
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/Suppliers/index.vue'),
      //   meta: {
      //     auth: ['admin', 'bn.cashier'],
      //     uniqueComponent: true,
      //   },
      // },
      // {
      //   path: '/labeReport',
      //   name: 'labeReports',
      //   component: () => import(/* webpackChunkName: "admin" */ '../views/LabReport/index.vue'),
      //   meta: {
      //     auth: ['admin', 'bn.cashier'],
      //   },
      // },
      {
        path: '/SystemConfig',
        name: 'SystemConfig',
        component: () => import(/* webpackChunkName: "admin" */ '../views/SystemConfig/index.vue'),
        meta: {
          auth: [roles.admin],
        },
      },
      {
        path: '/cms/agreement',
        name: 'cmsAgreement',
        component: () => import(/* webpackChunkName: "cms" */ '../views/Cms/PageEditor.vue'),
        props: { pageType: 'page.agreement', pageTitle: 'Agreement' },
        meta: {
          auth: [roles.admin],
          uniqueComponent: true,
        },
      },
      {
        path: '/cms/terms-and-condition',
        name: 'cmsTerms',
        component: () => import(/* webpackChunkName: "cms" */ '../views/Cms/PageEditor.vue'),
        props: { pageType: 'page.terms_and_condition', pageTitle: 'Terms and Condition' },
        meta: {
          auth: [roles.admin],
          uniqueComponent: true,
        },
      },
      {
        path: '/account-deletion-requests',
        name: 'accountDeletionRequests',
        component: () =>
          import(/* webpackChunkName: "admin" */ '../views/AccountDeletionRequest'),
        meta: {
          auth: [roles.admin],
        },
      },
    ],
  },
  {
    path: '/auth',
    name: 'authHome',
    component: authLayout,
    redirect: { name: 'login' },
    children: [
      {
        path: '/auth/login',
        name: 'login',
        component: LoginPage,
        props: r => ({ ret: r.query.ret }),
      },
      // {
      //   path: '/auth/forgetpassword',
      //   name: 'forgetpassword',
      //   component: () => import('../views/LoginPage/forgetpw.vue'),
      // },
      {
        path: '/auth/changeMyPassword',
        name: 'changeMyPassword',
        component: () => import('../views/ChangeMyPassword/index'),
      },
      {
        path: '/auth/resetpassword',
        name: 'resetPassword',
        component: () => import('../views/LoginPage/ResetPassword.vue'),
        props: r => ({ token: r.query.token }),
      },
      // {
      //   path: '/forgotpassword',
      //   name: 'Password',
      //   component: () => import('../views/LoginPage/resetpw.vue'),
      //   props: r => ({ token: r.query.token }),
      // },
    ],
  },
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;

router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.auth) {
    if (!store.getters['auth/isLoggedIn']) {
      return next({ name: 'login', query: { ret: to.fullPath } });
    }

    // Check clinic VIP status for clinic staff
    const userRole = store.getters['auth/role'];
    const clinicId = store.getters['auth/clinicId'];

    if (userRole === roles.clinicStaff && clinicId && to.name !== 'login') {
      try {
        const clinic = await crudRead(api, RESTFUL.clinicProfile.read, clinicId, {
          select: 'membership',
        });

        if (clinic && clinic.membership !== clinicMembership.vip) {
          // Store error message in store for display
          await store.dispatch('alert/updateAlertMessage', {
            msg: 'Your clinic VIP is not valid, please contact admin',
            type: 'error',
            color: 'error',
          });

          // Logout the user
          await store.dispatch('auth/logout');

          return next({
            name: 'login',
            query: {
              ret: to.fullPath,
              error: 'clinic_not_vip',
            },
          });
        }
      } catch (error) {
        console.error('Failed to check clinic VIP status:', error);
      }
    }

    if (Array.isArray(to.meta.auth)) {
      if (!to.meta.auth.includes(userRole)) {
        // prevent infinity redirection
        if (to.name === 'timetables' || to.name === 'Home') {
          return next({ name: 'login', query: { ret: to.fullPath } });
        }
        return next('/');
      }
    }
  }
  next();
});
router.afterEach((to, form) => {
  vuetify.framework.theme.themes.light = { ...defaults };
  switch (store.getters['auth/role']) {
    case roles.admin:
    //vuetify.framework.theme.themes.light.primary = '#9C27B0';
    // vuetify.framework.theme.themes.light.role = '#ECEFF1';
    // vuetify.framework.theme.themes.light.role_inverse = '#333333';
    // vuetify.framework.theme.themes.light.role_anchor = '#9C27B0';
    // vuetify.framework.theme.themes.light.role_timetableHeader = '#f3e5f5';
    // break;
    case roles.clinicStaff:
    //vuetify.framework.theme.themes.light.primary = '#ff9505';
    // vuetify.framework.theme.themes.light.role = '#ECEFF1';
    // vuetify.framework.theme.themes.light.role_inverse = '#333333';
    // vuetify.framework.theme.themes.light.role_anchor = '#9C27B0';
    // vuetify.framework.theme.themes.light.role_timetableHeader = '#f3e5f5';
    // break;
    default:
      //vuetify.framework.theme.themes.light.primary = '#ff9505';
      vuetify.framework.theme.themes.light.role = '#6ED2EE';
      vuetify.framework.theme.themes.light.role_inverse = '#00538A';
      vuetify.framework.theme.themes.light.role_anchor =
        vuetify.framework.theme.themes.light.menuSelected;
      vuetify.framework.theme.themes.light.role_timetableHeader = '#F4F4F4';
      break;
  }
  if (typeof to.meta?.theme === 'object' && to.meta?.theme) {
    Object.assign(vuetify.framework.theme.themes.light, to.meta.theme);
  }
});

export function canAccessRoute(to) {
  const r = router.resolve(to)?.route;
  if (!r) return false;
  const passAuthCheck =
    r && (!Array.isArray(r.meta?.auth) || r.meta.auth.includes(store.getters['auth/role']));
  const passDevCheck = r && (!r.meta?.isDevOnly || !!process.env.VUE_APP_SHOW_DEV_MENU_PATH);
  return passAuthCheck && passDevCheck;
}
